import type {
  ParseExcelResponse,
  ParseWordResponse,
  ImportRequest,
  ImportResult,
} from '@peles/shared';
import { apiClient } from './client';

export async function parseExcelFile(file: File): Promise<ParseExcelResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<ParseExcelResponse>('/import/parse-excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function parseWordFile(file: File): Promise<ParseWordResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<ParseWordResponse>('/import/parse-word', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function executeImport(request: ImportRequest): Promise<ImportResult> {
  const { data } = await apiClient.post<ImportResult>('/import/execute', request);
  return data;
}
